import { render, staticRenderFns } from "./DriversSection.vue?vue&type=template&id=263e9078&scoped=true"
import script from "./DriversSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DriversSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DriversSection.vue?vue&type=style&index=0&id=263e9078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263e9078",
  null
  
)

export default component.exports